import { FilterContextData } from 'contexts/FilterContext';
import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';

interface GrowthMarginBridgesContextType {
    selectedBridgesKPI: string;
    setSelectedBridgesKPI: (kpi: string) => void;
}

const GrowthMarginBridgesContext = createContext<GrowthMarginBridgesContextType | undefined>(undefined);

export const useGrowthMarginBridgesContext = () => {
    const context = useContext(GrowthMarginBridgesContext);
    if (!context) {
        throw new Error('useGrowthMarginBridgesContext must be used within a GrowthMarginBridgesProvider');
    }
    return context;
};

interface GrowthMarginBridgesProviderProps {
    children: ReactNode;
}

export const GrowthMarginBridgesProvider: React.FC<GrowthMarginBridgesProviderProps> = ({ children }) => {
    const { idForRestOfComponent } = useContext(FilterContextData);
    const [selectedBridgesKPI, setSelectedBridgesKPI] = useState<string>('');

    useEffect(() => {
        setSelectedBridgesKPI('');
    }, [idForRestOfComponent]);

    return (
        <GrowthMarginBridgesContext.Provider
            value={{
                selectedBridgesKPI,
                setSelectedBridgesKPI,
            }}
        >
            {children}
        </GrowthMarginBridgesContext.Provider>
    );
};
